import { useRef } from "react";

const Button = ({ className, text, background, color }) => {
  const buttonRef = useRef(null);
  const rafRef = useRef(null);

  const handleMove = (e) => {
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();

    const relX = e.clientX - (rect.left + rect.width / 2);
    const relY = e.clientY - (rect.top + rect.height / 2);

    const strength = 0.3;

    const x = relX * strength;
    const y = relY * strength;

    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      if(!buttonRef.current) return;
      buttonRef.current.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    });
  };

  const handleLeave = () => {
    if(!buttonRef.current) return;
    cancelAnimationFrame(rafRef.current);

    buttonRef.current.style.transform = "translate3d(0, 0, 0)";
    buttonRef.current.style.transition = "transform 0.4s ease";
  };

  const handleEnter = () => {
    if(!buttonRef.current) return;
    buttonRef.current.style.transition = "transform 0.1s ease";
  };

  return (
    <button
      ref={buttonRef}
      className={className}
      onMouseEnter={handleEnter}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      style={{
        background: background,
        color: color,
      }}
    >
      {text}
    </button>
  );
};

export default Button;